import { addMessages } from '@hana/i18n';

// Khoá chuỗi của ngăn Tạo yêu cầu hỏi giá (InquiryDrawer.tsx). Nội dung mail mẫu lấy từ inquiry.ts (chưa dịch).
addMessages('vi', {
  'iq.noWrite': 'Chưa bật ghi yêu cầu hỏi giá',
  'iq.title': 'Tạo yêu cầu hỏi giá đối tác / đại lý',
  'iq.draft': 'Lưu nháp',
  'iq.test': 'Gửi thử cho tôi',
  'iq.send': 'Gửi {n} đối tác',
  'iq.svc': 'Dịch vụ',
  'iq.langHead': 'Ngôn ngữ mail gửi đối tác',
  'iq.langAria': 'Ngôn ngữ mail',
  'iq.vi': 'Tiếng Việt',
  'iq.pickHead': 'Gửi cho đối tác / đại lý · {n} đã chọn',
  'iq.suggestMsg': 'Gợi ý 4 đối tác từng chào tuyến tương tự',
  'iq.suggest': 'Gợi ý theo tuyến',
  'iq.preview': 'Xem trước',
});
addMessages('en', {
  'iq.noWrite': 'Writing rate inquiries is not enabled',
  'iq.title': 'New rate inquiry to partners / agents',
  'iq.draft': 'Save draft',
  'iq.test': 'Send test to me',
  'iq.send': 'Send to {n} partners',
  'iq.svc': 'Service',
  'iq.langHead': 'Language of the mail to partners',
  'iq.langAria': 'Mail language',
  'iq.vi': 'Vietnamese',
  'iq.pickHead': 'Send to partners / agents · {n} selected',
  'iq.suggestMsg': 'Suggested 4 partners who quoted similar lanes',
  'iq.suggest': 'Suggest by lane',
  'iq.preview': 'Preview',
});
